import { render } from "./schedule-privacy-edit.vue?vue&type=template&id=1c854c94&lang=pug"
import script from "./schedule-privacy-edit.vue?vue&type=script&lang=js"
export * from "./schedule-privacy-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__